import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import image from '../assets/Logo.jpg';
import { Link } from "react-router-dom";
import { useState } from "react";
import emailjs from "@emailjs/browser";

function Contact() {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        mobile: "",
        address: "",
        course: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;

        // Restrict mobile input to only numbers and max 10 digits
        if (name === "mobile") {
            if (/^\d{0,10}$/.test(value)) {
                setFormData({ ...formData, [name]: value });
            }
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        // Construct the message for WhatsApp
        const whatsappMessage = `Hello, I am interested in your course.
        Name: ${formData.name}
        Email: ${formData.email}
        Mobile: ${formData.mobile}
        Address: ${formData.address}
        Selected Course: ${formData.course}`;

        // Encode message for URL
        const encodedMessage = encodeURIComponent(whatsappMessage);

        // Replace with your institute's WhatsApp number (with country code)
        const whatsappNumber = "919994141075"; // Example: 919876543210 (India)

        // Open WhatsApp with pre-filled message
        window.open(`https://wa.me/${whatsappNumber}?text=${encodedMessage}`, "_blank");

        // Sending form data to EmailJS
        emailjs.send(
            "service_gkxlhzd", // Replace with your EmailJS Service ID
            "template_ch3mivb", // Replace with your EmailJS Template ID
            {
                name: formData.name,
                email: formData.email,
                mobile: formData.mobile,
                address: formData.address,
                course: formData.course,
            },
            "fsesi7v0OogHEQw5l" // Replace with your EmailJS Public API Key
        )
            .then((response) => {
                alert("Form submitted successfully! Check your email and WhatsApp.");
                console.log("SUCCESS!", response.status, response.text);
            })
            .catch((error) => {
                alert("Failed to send email. Please try again.");
                console.log("FAILED...", error);
            });

        // Reset form
        setFormData({
            name: "",
            email: "",
            mobile: "",
            address: "",
            course: "",
        });
    };

    return (
        <>
            {/* Contact Info - Email (Left) & Phone (Right) */}
            <div className="d-flex flex-wrap justify-content-between align-items-center p-2 px-3 bg-light">
                <div className="d-flex align-items-center">
                    <FontAwesomeIcon icon={faEnvelope} className="me-2 text-orange" />
                    <span className="fw-bold">ultramobiles07@gmail.com</span>
                </div>
                <div className="d-flex align-items-center">
                    <FontAwesomeIcon icon={faPhone} className="me-2 text-orange" />
                    <span className="fw-bold">9994141075</span>
                </div>
            </div>
            {/* Navbar */}
            <nav className="navbar navbar-expand-lg navbar-light bg-light">
                <div className="container d-flex justify-content-between align-items-center">
                    {/* Logo and Institute Name */}
                    <div className="d-flex align-items-center">
                        <Link className="navbar-brand" to="/">
                            <img src={image} className="d-block" style={{ width: "70px" }} alt="Ultramobiles" />
                        </Link>
                        <div className="brand-title ms-2">Ultra Mobiles Training Institute</div>
                    </div>

                    {/* Navbar Toggle Button */}
                    <button
                        className="navbar-toggler"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarNav"
                        aria-controls="navbarNav"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>

                    {/* Navbar Links */}
                    <div className="collapse navbar-collapse justify-content-end" id="navbarNav">
                        <ul className="navbar-nav">
                            <li className="nav-item"><Link className="nav-link" to="/">Home</Link></li>
                            <li className="nav-item"><Link className="nav-link" to="/course">Course</Link></li>
                            <li className="nav-item"><Link className="nav-link" to="/about">About</Link></li>
                            <li className="nav-item"><Link className="nav-link" to="/contact">Contact</Link></li>
                        </ul>
                    </div>
                </div>
            </nav>

            {/* Contact Form Section */}
            <div className="container mt-5">
                <h2 className="text-center text-orange">Contact Us</h2>
                <p className="text-center text-muted">Fill out the form below to get in touch with us.</p>

                <div className="row justify-content-center">
                    <div className="col-md-6">
                        <div className="card p-4 shadow-sm">
                            <form onSubmit={handleSubmit}>
                                {/* Name Field */}
                                <div className="mb-3">
                                    <label className="form-label">Name</label>
                                    <input type="text" className="form-control" name="name" value={formData.name} onChange={handleChange} required />
                                </div>
                                {/* Email Field */}
                                <div className="mb-3">
                                    <label className="form-label">Email</label>
                                    <input type="email" className="form-control" name="email" value={formData.email} onChange={handleChange} required />
                                </div>
                                {/* Mobile Field */}
                                <div className="mb-3">
                                    <label className="form-label">Mobile</label>
                                    <input type="text" className="form-control" name="mobile" value={formData.mobile} onChange={handleChange} required />
                                </div>
                                {/* Address Field */}
                                <div className="mb-3">
                                    <label className="form-label">Address</label>
                                    <textarea className="form-control" name="address" rows="3" value={formData.address} onChange={handleChange} required></textarea>
                                </div>
                                {/* Course Selection */}
                                <div className="mb-3">
                                    <label className="form-label">Select Course</label>
                                    {["Basic Mobile Repairing", "Advanced Mobile Repairing", "Chip-Level Training"].map((course) => (
                                        <div className="form-check" key={course}>
                                            <input className="form-check-input" type="radio" name="course" value={course} checked={formData.course === course} onChange={handleChange} required />
                                            <label className="form-check-label">{course}</label>
                                        </div>
                                    ))}
                                </div>
                                {/* Submit Button */}
                                <div className="d-grid">
                                    <button type="submit" className="btn btn-warning">Submit</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>        
            {/* Footer */}
            <footer className="bg-orange text-white text-center p-3 mt-4">
                <p className="mb-0">COPYRIGHT © 2025 Ultramobiles Training Institute. All Rights Reserved.</p>
            </footer>

            <style>
                {`
                    .brand-title { font-weight: bold; font-size: 1.3rem; }
                    .text-orange { color: orange; }
                    .bg-orange { background: orange; }
                `}
            </style>
        </>
    );
}

export default Contact;
